import React from 'react';
import type { Creator, Video, AnalyticsData, NavItem } from './types';
import { Platform } from './types';
import { HomeIcon, SearchIcon, LibraryIcon } from './components/Icons';

export const creators: Creator[] = [
  {
    id: '1',
    name: 'Sophia Carter',
    handle: '@sophia.carter',
    avatarUrl: 'https://picsum.photos/id/1027/200/200',
    platform: Platform.Instagram,
    isLive: true,
    videos: [
      { id: 'v1', creatorName: 'Sophia Carter', title: 'Mastering the Art of Storytelling', thumbnailUrl: 'https://picsum.photos/seed/v1/400/300', views: '12K', uploadedAt: '2d ago', platform: Platform.Instagram, notes: 'Great example of color grading.' },
      { id: 'v2', creatorName: 'Sophia Carter', title: 'A Day in My Life', thumbnailUrl: 'https://picsum.photos/seed/v2/400/300', views: '25K', uploadedAt: '5d ago', platform: Platform.Instagram },
      { id: 'v3', creatorName: 'Sophia Carter', title: 'My Top 5 Camera Gears', thumbnailUrl: 'https://picsum.photos/seed/v3/400/300', views: '18K', uploadedAt: '1w ago', platform: Platform.Instagram },
      { id: 'v4', creatorName: 'Sophia Carter', title: 'Content Strategy for 2024', thumbnailUrl: 'https://picsum.photos/seed/v4/400/300', views: '30K', uploadedAt: '2w ago', platform: Platform.Instagram, notes: 'Need to analyze this strategy.' },
      { id: 'v5', creatorName: 'Sophia Carter', title: 'Exploring the Alps', thumbnailUrl: 'https://picsum.photos/seed/v5/400/300', views: '50K', uploadedAt: '3w ago', platform: Platform.Instagram },
      { id: 'v6', creatorName: 'Sophia Carter', title: 'How I edit my photos', thumbnailUrl: 'https://picsum.photos/seed/v6/400/300', views: '42K', uploadedAt: '1mo ago', platform: Platform.Instagram, notes: 'Good lighting setup.' },
      { id: 'v7', creatorName: 'Sophia Carter', title: 'Q&A Session with followers', thumbnailUrl: 'https://picsum.photos/seed/v7/400/300', views: '22K', uploadedAt: '1mo ago', platform: Platform.Instagram },
      { id: 'v8', creatorName: 'Sophia Carter', title: 'My new studio tour', thumbnailUrl: 'https://picsum.photos/seed/v8/400/300', views: '35K', uploadedAt: '2mo ago', platform: Platform.Instagram },
    ]
  },
  {
    id: '2',
    name: 'Ethan',
    handle: '@ethan_creates',
    avatarUrl: 'https://picsum.photos/id/1005/200/200',
    platform: Platform.YouTubeShorts,
    videos: [
      { id: 'v9', creatorName: 'Ethan', title: 'Behind the Scenes of My Latest Project', thumbnailUrl: 'https://picsum.photos/seed/v9/400/300', views: '8K', uploadedAt: '3d ago', platform: Platform.YouTubeShorts },
    ]
  },
  {
    id: '3',
    name: 'Olivia',
    handle: '@olivia_explores',
    avatarUrl: 'https://picsum.photos/id/1011/200/200',
    platform: Platform.TikTok,
    videos: [
      { id: 'v10', creatorName: 'Olivia', title: 'Quick Tips for Better Engagement', thumbnailUrl: 'https://picsum.photos/seed/v10/400/300', views: '15K', uploadedAt: '4d ago', platform: Platform.TikTok, notes: 'Viral sound usage.' },
    ]
  },
  {
    id: '4',
    name: 'Noah',
    handle: '@noah_tech',
    avatarUrl: 'https://picsum.photos/id/1012/200/200',
    platform: Platform.YouTubeShorts,
    videos: []
  },
];

export const recentVideos: Video[] = [
  creators[0].videos[0],
  creators[1].videos[0],
  creators[2].videos[0],
];

export const savedVideosData: Video[] = [
    { id: 'sv1', creatorName: 'Creator 1', title: 'Amazing Waterfall', thumbnailUrl: 'https://picsum.photos/seed/sv1/360/640', views: '1M', uploadedAt: '1w ago', platform: Platform.Instagram, notes: 'Great example of color grading.' },
    { id: 'sv2', creatorName: 'Creator 2', title: 'City at Night', thumbnailUrl: 'https://picsum.photos/seed/sv2/360/640', views: '500K', uploadedAt: '2w ago', platform: Platform.TikTok },
    { id: 'sv3', creatorName: 'Creator 3', title: 'Forest Trail', thumbnailUrl: 'https://picsum.photos/seed/sv3/360/640', views: '800K', uploadedAt: '3d ago', platform: Platform.YouTubeShorts, notes: 'Check the stabilization technique.' },
    { id: 'sv4', creatorName: 'Creator 4', title: 'Beach Sunset', thumbnailUrl: 'https://picsum.photos/seed/sv4/360/640', views: '2.5M', uploadedAt: '1d ago', platform: Platform.Facebook },
    { id: 'sv5', creatorName: 'Creator 5', title: 'Mountain Hike', thumbnailUrl: 'https://picsum.photos/seed/sv5/360/640', views: '950K', uploadedAt: '5d ago', platform: Platform.Twitter, notes: 'Short, punchy content.' },
    { id: 'sv6', creatorName: 'Creator 6', title: 'Street Food Tour', thumbnailUrl: 'https://picsum.photos/seed/sv6/360/640', views: '1.2M', uploadedAt: '1mo ago', platform: Platform.Threads },
];


export const analyticsData: AnalyticsData = {
    views: [
        { name: 'Jan', views: 1100000 },
        { name: 'Feb', views: 1400000 },
        { name: 'Mar', views: 1200000 },
        { name: 'Apr', views: 1800000 },
        { name: 'May', views: 1600000 },
        { name: 'Jun', views: 2100000 },
    ],
    engagement: [
        { name: Platform.Instagram, engagement: 45 },
        { name: Platform.YouTubeShorts, engagement: 70 },
        { name: Platform.TikTok, engagement: 90 },
    ],
    performance: [
        { name: Platform.Instagram, performance: 55 },
        { name: Platform.YouTubeShorts, performance: 80 },
        { name: Platform.TikTok, performance: 30 },
    ]
};

export const mainNavItems: NavItem[] = [
  { href: '/', labelKey: 'nav.home', icon: React.createElement(HomeIcon, { variant: 'stroke' }) },
  { href: '/library', labelKey: 'nav.library', icon: React.createElement(LibraryIcon, { variant: 'stroke' }) },
  { href: '/search', labelKey: 'nav.search', icon: React.createElement(SearchIcon, { variant: 'stroke' }) },
];